const fetchAreas = {
  text: 'No results found'
}

export default fetchAreas;
